import React from 'react';
import { connect } from 'react-redux'
import { List } from 'antd';
import { subsetByLang, getValues, getValuesAsIs } from '../../virtuoso/helper';
import { AdmsRepository, RdfTriplet } from '../../redux';
import { ADMSRDF } from '../../const/C';

/** Формирует последовательность таксономии. 
 * Ищет в концептах схему, которая должна быть назначена 
 */
const sortConcepts = concepts => {
  let j = 0;
  for (let i = 0; i < ADMSRDF.TAXONOMY_SEQUENCE.length; i++) {
      const IRI = ADMSRDF.TAXONOMY_SEQUENCE[i];
      //Может отсутствовать назначение концепта из списка схем
      //console.log("TaxonomyValues.js sortConcepts", IRI, concepts);
      const pos = concepts.map(item => item.inScheme).indexOf(IRI);
      if (pos<0) {
        console.warn("Taxonomy for scheme ",IRI, " not set. Concepts -", concepts);
        continue;
      }
      if (j==pos) {j++ ; continue};
      if (j>=(concepts.length-1)) break;
      [concepts[pos], concepts[j]] = [concepts[j], concepts[pos]];
      j++;
  }
  return concepts;
}

/** Отображение таксономии.  Для отображения используется List (см. https://ant.design/components/list/), который содержит:
 * 1. Заголовок - название такосномии (наименование КонцептСхемы). 
 * 2. Тело - значение (наименование концепта)
 * 3. Входным прараметром является URI предиката, который содержит объекты (object, обычно IRI) значений.
 * Для SKOS это индивидуалы skos:Concept 
 * 
 * При получении URI предиката, подучаем список IRI, которые содержат значения таксономии (для SKOS это skos:Concept)
 * 
 * */
class TaxonomyValuesCard extends React.Component {
  state = {
    loading: false,
    concepts: [],
  }
  
  componentDidMount() {
    this.loadTaxonomyValues()
  }

  componentWillReceiveProps(nextProps){
    const {predicat} = nextProps;
    if (this.state.predicat!=predicat)
      this.loadTaxonomyValues();
  }

  loadTaxonomyValues() {
    const {predicat, values, taxonomy, lang, graph} = this.props;
    this.setState({loading: true, predicat});
    //Получаем список ссылок
    const data = getValuesAsIs(predicat, lang, values);
    const concepts = data.map(iri => {
      return {concept: iri, scheme: iri};
    })
    this.setState({concepts});
    const result = data.map(iri => RdfTriplet.loadSubject(iri));
    //Надо проверить, что загружено описание схем
    // const schemas = taxonomy.filter(item => ( typeof item.state == 'undefined') || (item.state != "loaded"))
    //   .map(item => this.props.dispatch(AdmsRepository.loadTaxonomy(item.IRI.value)));
    //console.log("TaxonomyValues.js loadTaxonomyValues()", taxonomy, schemas);

    Promise.all(result)
      .then(result => {
        //console.log("RdfAction.loadSubject", result);
        const data = result.map(concept => {
          const label = getValues("http://www.w3.org/2000/01/rdf-schema#label", lang, concept.bindings);
          const getIRI = getValues("http://www.w3.org/2004/02/skos/core#inScheme", lang, concept.bindings);
          const schemaIRI = (getIRI)? getIRI: null;
          const schemeItems = (Array.isArray(taxonomy))?taxonomy.filter(item => item.IRI && (item.IRI.value==schemaIRI)):null;
          const schemaLabels = (Array.isArray(schemeItems)&&(schemeItems.length>0)&& schemeItems[0].schema)? subsetByLang(schemeItems[0].schema, lang, "label"):[];
          const scheme =  (schemaLabels.length>0)?schemaLabels[0].label.value: `Схема для ${concept.subject} отсутствует`;
          //console.log("TaxonomyValues.js loadTaxonomyValues() => !!!!!!", concept, label, scheme);
          return {iri: concept.subject, concept: label, scheme, inScheme: getIRI, isSchemeLabel: schemaLabels.length>0};
        });
        //Надо отсортировать концепты в соответствии со схемой 
        //console.log("TaxonomyValues.js loadTaxonomyValues()", data, result);
        this.setState({concepts: sortConcepts(data), loading: false});
        return {concepts: data, loading: false};
      })
      .then(data => {
        //Обработаем возможную дозагрузку схемы
        const schemas = data.concepts.filter(item => !item.isSchemeLabel).map(item => this.props.dispatch(AdmsRepository.loadTaxonomy(item.inScheme)));
        if (schemas.length>0){
            Promise.all(schemas).then(result => {
              const items =  data.concepts.map(concept => {
                const schemeItems = (Array.isArray(this.props.taxonomy))?this.props.taxonomy.filter(item => item.IRI && (item.IRI.value==concept.inScheme)):null;
                const schemaLabels = (Array.isArray(schemeItems)&&(schemeItems.length>0)&& schemeItems[0].schema)? subsetByLang(schemeItems[0].schema, lang, "label"):[];
                const scheme =  (schemaLabels.length>0)?schemaLabels[0].label.value: `Схема для ${concept.iri} отсутствует`;      
                return Object.assign({},concept, {scheme});
              })
            console.log("TaxonomyValues.js loadTaxonomyValues()", data, result, items);
            this.setState({concepts: sortConcepts(items), loading: false});
          });
        };
      });
  }
    
    
  render() {
    console.log(this);
    const { loading, concepts } = this.state;
    return (
      <span>
        <List
          className="demo-loadmore-list"
          loading={loading}
          itemLayout="horizontal"
          dataSource={concepts}
          renderItem={item => (
            <List.Item actions={[]}>
                <List.Item.Meta 
                  title={<span className="csi_cat_title">{item.scheme}</span>}
                  description={item.concept}
                />
            </List.Item>
          )}
        />
      </span>
    );
  }
}
  
  //Представление информации о ЕМД
export default connect(
  (state, props) => {
    const {vadms, vset, vasset} = state;
    const {lang, graph } = props;
    return ({
      lang: (lang)?lang: vset.lang,
      graph: (graph)?graph: vset.graph,
      taxonomy: vadms.taxonomy,
      values: vasset.values,      //Текущие данные
    })
  },
  null //dispatch => ({})
)(TaxonomyValuesCard)
